import { createContext, useContext } from 'react'

const IsAuthenticatedContext = createContext<boolean>(false)

export const IsAuthenticatedProvider = IsAuthenticatedContext.Provider

export const useIsAuthenticated = () => useContext(IsAuthenticatedContext)
